import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Remonte automatiquement en haut de la page à chaque changement de route.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

export default ScrollToTop;
